import styles from "./MasterUI.module.css";

import { SettingsWorkBox } from "../workBoxes/SettingsWorkBox";
import React, { useCallback, useRef, useState } from "react";
import { MasterTopBar } from "./MasterTopBar";
import { useOuterClickManyTargets } from "@kalyzee/kast-web-sdk/web-components";
import clsx from "clsx";

export interface MasterUIProps {
  children: React.ReactNode;
  onBack?: () => void;
}

export const MasterUI = React.memo(({ children, onBack }: MasterUIProps) => {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const settingsBtnRef: React.RefObject<HTMLDivElement> = useRef(null);
  const settingsBoxRef: React.RefObject<HTMLDivElement> = useRef(null);

  useOuterClickManyTargets([settingsBtnRef, settingsBoxRef], () => {
    setSettingsOpen(false);
  });

  const onSettings = useCallback(() => {
    setSettingsOpen(v => !v);
  }, []);

  const renderSettingsOverlayWorkBox = () => {
    return (
      <SettingsWorkBox 
        containerRef={settingsBoxRef}
        className={clsx({
          [styles.settingsBox]: true,
          [styles.invisible]: !settingsOpen,
        })}
      />
    );
  };
  
  return (
    <div className={styles.container}>
      <MasterTopBar
        onSettings={onSettings}
        onBack={onBack}
        settingsBtnRef={settingsBtnRef}
      />
      <div className={styles.content}>
        {children}
        {renderSettingsOverlayWorkBox()}
      </div>
    </div>
  );
});